import AgentNotificationContentClasses from './agent_notification_content_classes';
import TypeReflect from 'models/lib/type_reflect';

export const typeReflect = new TypeReflect(AgentNotificationContentClasses);

export default function(content) {
  function getContentClass(contentType) {
    try {
      return typeReflect.typeToConstructor(contentType);
    } catch (e) {
      throw new Error(`unknown agent notification content type [${contentType}]`);
    }
  }

  return getContentClass(content.type).fromJs(content);
}
